export const RoleWebMap = {
    admin: '/admin',
    dev: '/admin',
    installer: '/installer',
    user: '/user',
    service: '/admin',
};
/** Application Store Type */
export const APP_STORE_TYPE = {
    GOOGLE: 'google',
    APPLE: 'apple',
};
export const MOBILE_APP_TYPE = {
    PRO: 'pro',
    HOME: 'home',
};
